import { SkillLevels } from '@borg/types';

export function getSkillLevels() {
  const { t } = useI18n();
  return SkillLevels.map((key) => ({
    value: key,
    label: t(`SKILL.LEVEL.${key.toUpperCase()}`),
  }));
}
